import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@storable/canaveral-components';
import Button from '../../../../../modules/react/components/stateless/Button';
import styles from './Modal.scss';

const ConfirmReplaceModal = ({ onClose, onConfirm }) => (
  <Modal
    show
    onDismiss={onClose}
    aria-labelledby="confirm-replace-modal"
  >
    <Modal.Header>
      <Modal.Title id="confirmReplace">Confirm Replacement</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className={styles.message}>
        You already have a live version of this page. Do you want to replace the current live version
        with this version?
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="danger">
        Replace
      </Button>
    </Modal.Footer>
  </Modal>
);

ConfirmReplaceModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmReplaceModal;
